import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import appconst from './../../lib/appconst';
import InvoiceSeqItem from '@/store/entities/invoice-seq-line-view'
interface InvoiceSeqState extends ListState<InvoiceSeqItem> {
    statuses:[];
}
class InvoiceSeqModule extends ListModule<InvoiceSeqState, any, InvoiceSeqItem>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<InvoiceSeqItem>(),
        loading: false,
        statuses :[]
    }
    actions = {
        async getAll(context: ActionContext<InvoiceSeqState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/InvoiceSeqLine/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<InvoiceSeqItem>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getStatusesForSelect(context: ActionContext<InvoiceSeqState, any>, payload: any) {
            const {data:{result} } = await Ajax.get('/api/services/app/InvoiceSeq/GetStatusForSelect', { params : payload.data });
            context.state.statuses = result.items;
        },
        async create(context: ActionContext<InvoiceSeqState, any>, payload: any) {
            await Ajax.post('/api/services/app/InvoiceSeq/Create', payload.data);
        },
        async cancel(context: ActionContext<InvoiceSeqState, any>, payload: any) {
            await Ajax.post('/api/services/app/InvoiceSeq/Cancel/', payload.data);
        }
    };
    mutations = {
        setCurrentPage(state: InvoiceSeqState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: InvoiceSeqState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}
const invoiceSeqModule = new InvoiceSeqModule();
export default invoiceSeqModule;